export interface PopupState {
  lastTriggered?: string
  triggeredTimes: number
  suppressUntil?: string
}

export interface PopupStorage {
  [key: string]: PopupState
  global: PopupState
}

/**
 * 確保 PopupState 是完整的
 */
const ensurePopupState = (state?: Partial<PopupState>): PopupState => ({
  triggeredTimes: state?.triggeredTimes ?? 0,
  lastTriggered: state?.lastTriggered,
  suppressUntil: state?.suppressUntil,
})

export const getPopupKey = (popupId: string | number) => `popup_${popupId}`

let STORAGE_KEY = 'popup_states'

export const popupStorage = {
  /**
   * 用於設定 fp 不同 campaign 的 popup_states
   * 如果沒有 campaignId，代表是官網品牌，因為 domain 不同，因此可以直接用 popup_states
   */
  init: (id?: number | string) => {
    STORAGE_KEY = id ? `popup_states_${id}` : STORAGE_KEY
  },
  get: (): PopupStorage => {
    try {
      const data = localStorage.getItem(STORAGE_KEY)
      const parsed = data ? JSON.parse(data) : {}
      return {
        ...parsed,
        global: ensurePopupState(parsed.global as PopupState),
      }
    }
    catch {
      return {
        global: ensurePopupState(),
      }
    }
  },

  getPopupState: (popupId: string | number): PopupState => {
    const storage = popupStorage.get()
    return ensurePopupState(storage[getPopupKey(popupId)])
  },

  set: (state: PopupStorage): void => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
    }
    catch (error) {
      console.error('Failed to save popup state:', error)
    }
  },

  updatePopup: (popupId: string | number, updater: (state: PopupState) => PopupState): void => {
    const storage = popupStorage.get()
    const popupKey = getPopupKey(popupId)

    popupStorage.set({
      ...storage,
      [popupKey]: updater(ensurePopupState(storage[popupKey])),
    })
  },
}
